const sprintIconSpritesheet = {
  "name": "sprintIconSpritesheet",
  "tileHeight": 64,
  "tileWidth": 64,
  "spacing": 0,
  "tileCount": 1,
  "columns": 1,
  "animationSpeed": 0.1,
  "spritesheet": "./assets/spritesheets/sprintIconSpritesheet.png",
  "sprites": {
    "sprintTouchIcon": [0]
  }
}
export default sprintIconSpritesheet;
